import React, { useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet";
import { getPreloadedData, PreloadedScript } from "../utils/preloadedData";
import { ensureMetaDescription } from "../utils/metaDescription";
import useClientReady from "../utils/useClientReady";
import { formatDate } from "../utils/formatDate";
import "./../JobPostDetailPage/JobPostDetailPage.css";
import Navbarsynergtech from "../Homepage/Navbarsynergtech/Navbarsynergtech";
import FooterAll from "../Homepage/FooterAll/FooterAll";
import Footer from "../Homepage/Footer/Footer";
import { CiLocationOn } from "react-icons/ci";
import { CiDollar } from "react-icons/ci";
import arrow from "./../../Assets/arrow_blue.png";
import { FaFacebookF, FaFacebook, FaTwitter, FaPinterest, FaInstagram, FaLinkedin, FaYoutube } from "react-icons/fa";
import { FaInstagram as FaInstagram6 } from "react-icons/fa6";
import category from "./../../Assets/category_over.png";
import date from "./../../Assets/date_over.png";
import location from "./../../Assets/location_over.png";
import salary from "./../../Assets/salary_over.png";
import Experience from "./../../Assets/exp_over.png";
import gender from "./../../Assets/gender_over.png";
import qualification from "./../../Assets/qualitfication_over.png";
import arrow_send_mesg from "./../../Assets/send_mesg_over.png";
import axiosInstance from "./../api/axiosInstance";
import synergy from "./../../Assets/synergy-logo-main.png";
import clock from "./../../Assets/clock_syn.png";
import { useLocation, useNavigate, useParams, Link } from "react-router-dom";
import phone from "./../../Assets/phone_syn.png";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { IoReorderThreeOutline } from "react-icons/io5";
import Appointment from "../Homepage/Appointment/Appointment";
import { trackEvent } from "../utils/trackEvent";
import { formatSalary } from "../utils/formatSalary";

// Helper function to create a URL-friendly slug from the title (matches the
// format used by NewJobOpenings.js links and every other dynamic detail page)
const createSlug = (title) => {
  if (!title) return "";
  return title
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, "")
    .trim()
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-");
};

// Helper to build a safe, truncated meta description from plain text
const truncateForMeta = (text, maxLength = 160) => {
  if (!text) return "";
  const plain = text.replace(/\s+/g, " ").trim();
  return plain.length > maxLength ? plain.slice(0, maxLength).trim() + "..." : plain;
};

function JobPostDetail() {
  const [showApplyModal, setShowApplyModal] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    resume: null,
    job_id: null,
  });

  const [errors, setErrors] = useState({
    name: "",
    email: "",
    phone: "",
    resume: "",
  });

  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  };

  const validatePhone = (phone) => {
    const phoneNumber = phone.replace(/\D/g, "");
    return phoneNumber.length >= 10 && phoneNumber.length <= 15;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
    setErrors({ ...errors, [name]: "" });
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.type !== "application/pdf") {
        toast.error("Please select a PDF file");
        setErrors({ ...errors, resume: "Please select a PDF file" });
        setFormData({ ...formData, resume: null });
        e.target.value = "";
        return;
      }
      if (file.size > 5 * 1024 * 1024) {
        toast.error("File size should be less than 5MB");
        setErrors({ ...errors, resume: "File size should be less than 5MB" });
        setFormData({ ...formData, resume: null });
        e.target.value = "";
        return;
      }
      setFormData({ ...formData, resume: file });
      setErrors({ ...errors, resume: "" });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    let newErrors = {};
    let isValid = true;

    if (!formData.name.trim()) {
      newErrors.name = "Name is required";
      isValid = false;
    }

    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
      isValid = false;
    } else if (!validateEmail(formData.email)) {
      newErrors.email = "Please enter a valid email";
      isValid = false;
    }

    if (!formData.phone.trim()) {
      newErrors.phone = "Phone number is required";
      isValid = false;
    } else if (!validatePhone(formData.phone)) {
      newErrors.phone = "Phone number must be between 10 and 15 digits";
      isValid = false;
    }

    if (!formData.resume) {
      newErrors.resume = "Please upload a PDF resume";
      isValid = false;
    }

    setErrors(newErrors);

    if (!isValid) {
      toast.error("Please fix the errors in the form");
      return;
    }

    const formToSubmit = new FormData();
    formToSubmit.append("name", formData.name);
    formToSubmit.append("email", formData.email);
    formToSubmit.append("phone", formData.phone);
    formToSubmit.append("resume", formData.resume);
    formToSubmit.append("job_id", job.id);

    try {
      const response = await axiosInstance.post("api/apply-job", formToSubmit, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (response.status === 200 || response.status === 201) {
        trackEvent("job_application_submitted");
        setFormData({
          name: "",
          email: "",
          phone: "",
          resume: null,
          job_id: null,
        });
        toast.success("Submitted successfully!", {
          position: "top-right",
          autoClose: 3000,
        });
        setShowApplyModal(false);
      }
    } catch (error) {
      console.error("Error submitting the form", error);
      toast.error("Failed to submit the form. Please try again.", {
        position: "top-right",
        autoClose: 3000,
      });
    }
  };

  const appointmentRef = useRef(null);

  const scrollToAppointment = () => {
    if (appointmentRef.current) {
      appointmentRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  const [isVisible, setIsVisible] = useState(false);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  const location = useLocation();
  const { jobId: jobIdParam } = useParams();
  // Prefer the URL param (reliable on refresh/direct load/sharing); fall back to
  // router state for any older in-app links that haven't been updated yet.
  const jobId = jobIdParam || location.state?.jobId;
  const navigate = useNavigate();
  const [job, setJob] = useState(() => getPreloadedData("__PRELOADED_JOB__"));
  const [similarJobs, setSimilarJobs] = useState(() => getPreloadedData("__PRELOADED_SIMILAR_JOBS__") || []);
  // Not loading when the prerendered snapshot already supplied the data, so the first client render matches it.
  const [loading, setLoading] = useState(() => getPreloadedData("__PRELOADED_JOB__") === null);
  const clientReady = useClientReady();
  const [currentPage, setCurrentPage] = useState(1);
  const jobsPerPage = 4;

  useEffect(() => {
    if (!jobId) {
      console.error("No jobId provided in route state");
      setLoading(false);
      return;
    }

    const fetchJobDetails = async () => {
      try {
        const response = await axiosInstance.get(`api/jobs/${jobId}`);
        setJob(response.data);

        const similarResponse = await axiosInstance.get(
          `api/jobs?category=${response.data.category}&exclude=${jobId}`
        );
        setSimilarJobs(similarResponse.data || []);
      } catch (error) {
        console.error("Failed to fetch job details:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchJobDetails();
  }, [jobId]);

  if (loading) {
    return (
      <>
        <Helmet>
          <title>Loading Job... | 360 SynergyTech Careers</title>
        </Helmet>
        <div className="loader-container">
          <div className="loader">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </>
    );
  }
  if (!job) {
    return (
      <>
        <Helmet>
          <title>Job Not Found | 360 SynergyTech Careers</title>
          <meta name="robots" content="noindex" />
        </Helmet>
        <p>Job not found.</p>
      </>
    );
  }

  const jobPageDescription = ensureMetaDescription(truncateForMeta(job.description), job.title, "Job opening at 360 SynergyTech. View the role and apply online.");
  const jobCanonicalUrl = `https://360synergytech.com/job/description/${jobId}/${createSlug(job.title)}`;
  // Built as an object and stringified so it is always valid JSON. Only fields the page really has are
  // included: no baseSalary (the API stores no currency or pay period), no employmentType.
  // jobLocation.address must be a PostalAddress for Google; the admin-entered location text is the only
  // value available, so it goes in addressLocality and needs checking against real postings.
  const jobPostingJsonLd = JSON.stringify({
    "@context": "https://schema.org",
    "@type": "JobPosting",
    title: job.title,
    description: job.description || "",
    datePosted: job.date_posted,
    validThrough: job.expiry_date,
    hiringOrganization: {
      "@type": "Organization",
      name: "360 SynergyTech",
      sameAs: "https://360synergytech.com",
    },
    ...(job.location
      ? { jobLocation: { "@type": "Place", address: { "@type": "PostalAddress", addressLocality: job.location } } }
      : {}),
  });


  // Depends on "now", so it is only evaluated in a live browser: the prerender snapshot only contains open
  // jobs and a stale snapshot must not disagree with a visitor who loads it after the deadline.
  const isExpired = clientReady && new Date(job.expiry_date) < new Date();
  const indexOfLastJob = currentPage * jobsPerPage;
  const indexOfFirstJob = indexOfLastJob - jobsPerPage;
  const currentJobs = similarJobs.slice(indexOfFirstJob, indexOfLastJob);
  const totalPages = Math.ceil(similarJobs.length / jobsPerPage);

  const jobDescription = (job) => {
    navigate(`/job/description/${job.id}/${createSlug(job.title)}`);
    setTimeout(() => {
      scrollToTop();
    }, 100);
  };

  const handleSocialMediaClick = (platform) => {
    const urls = {
      facebook: "https://www.facebook.com/360SynergyTech/",
      twitter: "https://x.com/360SynergyTech",
      instagram: "https://www.instagram.com/360synergytech/",
      pinterest: "https://www.pinterest.com",
    };
    window.open(urls[platform], "_blank", "noopener,noreferrer");
  };

  const handleSendMessage = () => {
    window.location.href =
      "mailto:info@360synergytech.com?subject=Job Inquiry&body=Hello, I am interested in the job posting.";
  };

  const closeApplyModal = () => {
    setShowApplyModal(false);
    setErrors({ name: "", email: "", phone: "", resume: "" });
  };

  const handlePageChange = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  return (
    <div>
      <PreloadedScript id="__PRELOADED_JOB__" data={job} />
      <PreloadedScript id="__PRELOADED_SIMILAR_JOBS__" data={similarJobs} />
      {isVisible && (
        <button onClick={scrollToTop} className="scroll-to-top-button">
          <span>↑</span>
        </button>
      )}
      <Helmet>
        <title>{`${job.title} | Careers at 360 SynergyTech`}</title>
        <meta name="description" content={jobPageDescription} />
        <link rel="canonical" href={jobCanonicalUrl} />
        {/* a closed posting should drop out of search; the sitemap already lists only open jobs */}
        {isExpired && <meta name="robots" content="noindex, follow" />}

        <meta property="og:title" content={`${job.title} | Careers at 360 SynergyTech`} />
        <meta property="og:description" content={jobPageDescription} />
        <meta property="og:url" content={jobCanonicalUrl} />
        <meta property="og:image" content="https://360synergytech.com/synergy-logo.png" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={`${job.title} | Careers at 360 SynergyTech`} />
        <meta name="twitter:description" content={jobPageDescription} />
        <meta name="twitter:image" content="https://360synergytech.com/synergy-logo.png" />

        <script type="application/ld+json">
          {jobPostingJsonLd}
        </script>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            itemListElement: [
              { "@type": "ListItem", position: 1, name: "Home", item: "https://360synergytech.com/" },
              { "@type": "ListItem", position: 2, name: "Careers", item: "https://360synergytech.com/careers" },
              { "@type": "ListItem", position: 3, name: job.title, item: jobCanonicalUrl },
            ],
          })}
        </script>
      </Helmet>
      <Navbarsynergtech scrollToAppointment={scrollToAppointment} />
      <div className="main_div_designation">
        <div className="row m-0 p-0">
          <div className="col-lg-2 col-md-1 col-sm-12 col-12"></div>
          <div className="col-lg-8 col-md-9 col-sm-12 col-12">
            <div className="row p-0 m-0">
              <div className="col-lg-8 col-md-12 col-sm-12 col-12">
                <div className="main_description_designation">
                  <h1 className="header_designation" style={{ marginTop: 0, marginBottom: "1rem" }}>{job.title}</h1>
                  <div className="d-flex flex-row">
                    <p className="by_description">By</p>
                    <p className="Spotify_description">360 SynergyTech</p>
                    <p className="by_description">in</p>
                    <p className="Design_Creative_description">{job.category}</p>
                  </div>
                  <div className="d-flex flex-row flex-wrap">
                    <button className="btn_in_house">{job.mode}</button>
                    <button className="btn_in_house">
                      <CiLocationOn />{` ${job.location}`}
                    </button>
                    <button className="btn_in_house">
                      <CiDollar />{` ${formatSalary(job.salary)}`}
                    </button>
                  </div>
                  <hr className="hr_line_below_header" />
                  <p className="description_heading">Description</p>
                  <p className="description_para_designation">{job.description}</p>

                  <p className="description_heading">Requirements</p>
                  <p className="description_para_designation">{job.requirements}</p>
                  {job.requirements &&
                    job.requirements.split("\n").map((req, index) => (
                      <div key={index} className="d-flex flex-row">
                        <img className="blue_arrow" src={arrow} alt="arrow" width="23" height="22" />
                        <p className="blue_Arrow_para">{req.trim()}</p>
                      </div>
                    ))}

                  <p className="description_heading">Skill & Experience</p>
                  <p className="description_para_designation">
                    {`${job.skills} | ${job.experience}`}
                  </p>
                  {job.skills &&
                    job.skills.split(",").map((skill, index) => (
                      <div key={index} className="d-flex flex-row">
                        <img className="blue_arrow" src={arrow} alt="arrow" width="23" height="22" />
                        <p className="blue_Arrow_para">{skill.trim()}</p>
                      </div>
                    ))}

                  <div className="d-flex flex-row flex-wrap">
                    <p className="share_job_post_para">Share job Post:</p>
                    <button
                      className="btn_facebook_post"
                      onClick={() => handleSocialMediaClick("facebook")}
                    >
                      <FaFacebookF /> Facebook
                    </button>
                    <button
                      className="btn_Twitter_post"
                      onClick={() => handleSocialMediaClick("twitter")}
                    >
                      <FaTwitter /> Twitter
                    </button>
                    <button
                      className="btn_Pinterest_post"
                      onClick={() => handleSocialMediaClick("pinterest")}
                    >
                      <FaPinterest /> Pinterest
                    </button>
                  </div>

                  <hr className="hr_below_social_media" />

                  <p className="description_heading">Similar Jobs</p>
                  {currentJobs.map((similarJob) => (
                    <div className="card_div_jobs" key={similarJob.id}>
                      <div className="row m-0 p-0">
                        <div className="col-lg-8 col-md-9 col-sm-9 col-12">
                          <p className="title_card_jobs">
                            <Link to={`/job/description/${similarJob.id}/${createSlug(similarJob.title)}`} style={{ color: "inherit", textDecoration: "none" }}>
                              {similarJob.title}
                            </Link>
                          </p>
                          <div className="d-flex flex-row">
                            <p className="by_description">By</p>
                            <p className="Spotify_description">360 SynergyTech</p>
                            <p className="by_description">in</p>
                            <p className="Design_Creative_description_orange">
                              {similarJob.category}
                            </p>
                          </div>
                          <div className="d-flex flex-row flex-wrap">
                            <button className="btn_in_house_orange">{similarJob.mode}</button>
                            <button className="btn_in_house_orange">
                              <CiLocationOn />{` ${similarJob.location}`}
                            </button>
                            <button className="btn_in_house_orange">
                              <CiDollar />{` ${formatSalary(similarJob.salary)}`}
                            </button>
                          </div>
                        </div>
                        <div className="col-lg-4 col-md-3 col-sm-3 col-12">
                          <button
                            className="btn_aply_now"
                            onClick={() => jobDescription(similarJob)}
                          >
                            Apply Now
                          </button>
                        </div>
                      </div>
                    </div>
                  ))}
                  {totalPages > 1 && (
                    <div
                      className="pagination_div"
                      style={paginationStyles.container}
                    >
                      {[...Array(totalPages)].map((_, index) => {
                        const pageNumber = index + 1;
                        return (
                          <button
                            key={pageNumber}
                            onClick={() => handlePageChange(pageNumber)}
                            style={
                              currentPage === pageNumber
                                ? {
                                    ...paginationStyles.dot,
                                    ...paginationStyles.activeDot,
                                  }
                                : paginationStyles.dot
                            }
                          >
                            {pageNumber}
                          </button>
                        );
                      })}
                    </div>
                  )}
                </div>
              </div>
              <div className="col-lg-4 col-md-12 col-sm-12 col-12 px-2">
                <img
                  src={synergy || "/placeholder.svg"}
                  className="sidebar_brand_logo"
                  alt="360 SynergyTech"
                  width="250"
                  height="90"
                />
                <div className="hr_blue_second_div" />
                <p className="heading_interested_injob">Interested in this job?</p>
                <p className="para_interested">
                  {isExpired ? "Application deadline has expired" : "Apply before the deadline!"}
                </p>
                <div className="d-flex justify-content-between">
                  <button
                    className="apply_now_interested"
                    onClick={() => setShowApplyModal(true)}
                    disabled={isExpired}
                  >
                    Apply Now
                  </button>
                  {showApplyModal && (
                    <div
                      className="job_apply_modal_overlay"
                      role="dialog"
                      aria-labelledby="exampleModalLabel"
                      aria-modal="true"
                      onClick={closeApplyModal}
                    >
                      <div
                        className="job_apply_modal_content"
                        onClick={(e) => e.stopPropagation()}
                      >
                              <button
                                type="button"
                                className="close_apply_job_modal"
                                onClick={closeApplyModal}
                                aria-label="Close"
                              >
                                &times;
                              </button>
                          <p className="apply_job_heading_modal">Apply for Job</p>
                          <p className="apply_job_para_modal">Kindly fill the information</p>
                          <div className="form-group">
                            <input
                              name="name"
                              className={`input_model_job_apply ${errors.name ? "is-invalid" : ""}`}
                              placeholder="Name"
                              value={formData.name}
                              onChange={handleInputChange}
                            />
                            {errors.name && (
                              <div className="invalid-feedback">{errors.name}</div>
                            )}
                          </div>
                          <div className="form-group">
                            <input
                              name="email"
                              className={`input_model_job_apply ${errors.email ? "is-invalid" : ""}`}
                              placeholder="E-Mail"
                              value={formData.email}
                              onChange={handleInputChange}
                            />
                            {errors.email && (
                              <div className="invalid-feedback">{errors.email}</div>
                            )}
                          </div>
                          <div className="form-group">
                            <input
                              name="phone"
                              className={`input_model_job_apply ${errors.phone ? "is-invalid" : ""}`}
                              placeholder="Phone Number"
                              value={formData.phone}
                              onChange={handleInputChange}
                            />
                            {errors.phone && (
                              <div className="invalid-feedback">{errors.phone}</div>
                            )}
                          </div>
                          <div className="form-group">
                            <input
                              type="file"
                              className={`input_model_job_applyupload ${errors.resume ? "is-invalid" : ""}`}
                              onChange={handleFileChange}
                              accept="application/pdf"
                            />
                            {errors.resume && (
                              <div className="invalid-feedback">{errors.resume}</div>
                            )}
                          </div>
                          <button
                            type="button"
                            className="submit_apply_job_model"
                            onClick={handleSubmit}
                            disabled={
                              !formData.name ||
                              !formData.email ||
                              !formData.phone ||
                              !formData.resume
                            }
                          >
                            Submit
                          </button>
                          <ToastContainer />
                      </div>
                    </div>
                  )}
                </div>
                <div className="hr_line_below_aply_now" />
                <div className="over_view_main">
                  <p className="over_view_heading">Overview</p>
                  <div className="row m-0 p-0">
                    <div className="col-lg-2 col-md-2 col-sm-2 col-2">
                      <img className="icon_overview" src={category} alt="category" width="20" height="20" />
                    </div>
                    <div className="col-lg-10 col-md-10 col-sm-10 col-10">
                      <p className="heading_overview_para">Categories</p>
                      <p className="para_overview_para">{job.category}</p>
                    </div>
                  </div>
                  <div className="row m-0 p-0">
                    <div className="col-lg-2 col-md-2 col-sm-2 col-2">
                      <img className="icon_overview" src={date} alt="date" width="20" height="20" />
                    </div>
                    <div className="col-lg-10 col-md-10 col-sm-10 col-10">
                      <p className="heading_overview_para">Date Posted</p>
                      <p className="para_overview_para">
                        {formatDate(job.date_posted)}
                      </p>
                    </div>
                  </div>
                  <div className="row m-0 p-0">
                    <div className="col-lg-2 col-md-2 col-sm-2 col-2">
                      <CiLocationOn className="icon_overview" />
                    </div>
                    <div className="col-lg-10 col-md-10 col-sm-10 col-10">
                      <p className="heading_overview_para">Location</p>
                      <p className="para_overview_para">{job.location}</p>
                    </div>
                  </div>
                  <div className="row m-0 p-0">
                    <div className="col-lg-2 col-md-2 col-sm-2 col-2">
                      <img className="icon_overview" src={salary} alt="salary" width="20" height="20" />
                    </div>
                    <div className="col-lg-10 col-md-10 col-sm-10 col-10">
                      <p className="heading_overview_para">Offered Salary</p>
                      <p className="para_overview_para">
                        {formatSalary(job.salary)}
                      </p>
                    </div>
                  </div>
                  <div className="row m-0 p-0">
                    <div className="col-lg-2 col-md-2 col-sm-2 col-2">
                      <img className="icon_overview" src={date} alt="expiration" width="20" height="20" />
                    </div>
                    <div className="col-lg-10 col-md-10 col-sm-10 col-10">
                      <p className="heading_overview_para">Expiration Date</p>
                      <p className="para_overview_para">
                        {formatDate(job.expiry_date)}
                      </p>
                    </div>
                  </div>
                  <div className="row m-0 p-0">
                    <div className="col-lg-2 col-md-2 col-sm-2 col-2">
                      <img className="icon_overview" src={Experience} alt="experience" width="20" height="20" />
                    </div>
                    <div className="col-lg-10 col-md-10 col-sm-10 col-10">
                      <p className="heading_overview_para">Experience</p>
                      <p className="para_overview_para">{job.experience}</p>
                    </div>
                  </div>
                  <div className="row m-0 p-0">
                    <div className="col-lg-2 col-md-2 col-sm-2 col-2">
                      <img className="icon_overview" src={gender} alt="gender" width="20" height="20" />
                    </div>
                    <div className="col-lg-10 col-md-10 col-sm-10 col-10">
                      <p className="heading_overview_para">Gender</p>
                      <p className="para_overview_para">{job.gender}</p>
                    </div>
                  </div>
                  <div className="row m-0 p-0">
                    <div className="col-lg-2 col-md-2 col-sm-2 col-2">
                      <img
                        className="icon_overview"
                        src={qualification}
                        alt="qualification"
                        width="20"
                        height="20"
                      />
                    </div>
                    <div className="col-lg-10 col-md-10 col-sm-10 col-10">
                      <p className="heading_overview_para">Qualification</p>
                      <p className="para_overview_para">{job.qualification}</p>
                    </div>
                  </div>
                  <button className="send_us_btn" onClick={handleSendMessage}>
                    Send us message <img src={arrow_send_mesg} alt="send" width="15" height="15" />
                  </button>
                  <div className="d-flex justify-content-center">
                    <div className="d-flex flex-row">
                      <button
                        className="btn_social_media_links"
                        onClick={() => handleSocialMediaClick("twitter")}
                      >
                        <FaTwitter />
                      </button>
                      <button
                        className="btn_social_media_links"
                        onClick={() => handleSocialMediaClick("facebook")}
                      >
                        <FaFacebook />
                      </button>
                      <button
                        className="btn_social_media_links"
                        onClick={() => handleSocialMediaClick("instagram")}
                      >
                        <FaInstagram />
                      </button>
                      <button
                        className="btn_social_media_links"
                        onClick={() => handleSocialMediaClick("pinterest")}
                      >
                        <FaPinterest />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-2 col-md-1 col-sm-12 col-12"></div>
        </div>
      </div>
      <div ref={appointmentRef}>
        <Appointment />
      </div>
      <FooterAll />
      <Footer />
    </div>
  );
}

const paginationStyles = {
  container: {
    display: "flex",
    justifyContent: "center",
    marginTop: "20px",
    marginBottom: "20px",
  },
  dot: {
    width: "40px",
    height: "40px",
    borderRadius: "50%",
    backgroundColor: "#e0e0e0",
    margin: "0 5px",
    border: "none",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "16px",
    color: "#333",
    transition: "background-color 0.3s",
  },
  activeDot: {
    backgroundColor: "#0162ca",
    color: "#fff",
  },
};

export default JobPostDetail;